/**
 * @prettier
 */

import React from 'react';
import FeatureFlags from '../../../../../util/featureFlags';
import CardCorrectionReview from '../../CardCorrectionReview/CardCorrectionReview';

const OtherThingsToReview = () => {
  return FeatureFlags.get('invitesReviewTipsAllModals') ? (
    <CardCorrectionReview.Box>
      <CardCorrectionReview.Title>Other Things To Review</CardCorrectionReview.Title>
      <CardCorrectionReview.Tips />
    </CardCorrectionReview.Box>
  ) : null;
};

export default OtherThingsToReview;



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/TipsModals/OtherThingsToReview.jsx